// export default function Careers() {
//   return (
//     <main className="w-full">

//       {/* ================= PAGE HEADING ================= */}
//       <section className="bg-brandPurple py-10 text-center text-white">
//         <div className="max-w-7xl mx-auto px-5 text-center">

//           {/* Breadcrumb */}
//           <div className="text-sm text-[var(--brand-gray)] mb-2 flex justify-center items-center gap-2">
//             <a href="/" className="hover:text-[var(--brand-purple)]">
//               Home
//             </a>
//             <span className="text-gray-400">›</span>
//             <span>Careers</span>
//           </div>

//           {/* Title */}
//           <h1 className="text-3xl sm:text-4xl font-bold text-[var(--brand-dark)]">
//             Careers
//           </h1>
//         </div>
//       </section>

//       {/* ================= CONTENT ================= */}
//       <section className="py-14">
//         <div className="max-w-7xl mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">

//           {/* LEFT CONTENT */}
//           <div className="text-center">
//             <img
//               src="https://confidays.com/wp-content/uploads/2022/05/Marketing-executive-job-vacency-confidays-1024x1024.jpg"
//               alt="Marketing executive job vacancy - Confidays"
//               className="w-full max-w-md mx-auto rounded-lg shadow-md"
//             />

//             <a
//               href="mailto:info@confidays.com"
//               className="inline-block mt-6 px-8 py-3 bg-[var(--brand-purple)] text-white rounded-md font-medium hover:opacity-90 transition"
//             >
//               Apply Now
//             </a>
//           </div>

//           {/* RIGHT EMPTY COLUMN (as in Elementor layout) */}
//           <div />

//         </div>
//       </section>

//     </main>
//   );
// }




export default function Careers() {
  return (
    <main className="w-full font-poppins">

      {/* ================= PAGE HEADING ================= */}
      <section className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-center text-white">
        <div className="max-w-7xl mx-auto px-5 text-center">

          {/* Breadcrumb */}
          <div className="text-sm text-[var(--brand-gray)] mb-2 flex justify-center items-center gap-2">
            <a href="/" className="hover:text-[var(--brand-purple)]">
              Home
            </a>
            <span className="text-gray-400">›</span>
            <span>Careers</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--brand-dark)]">
            Careers
          </h1>
        </div>
      </section>

      {/* ================= CONTENT ================= */}
      <section className="py-14 bg-gradient-to-b from-green-50 to-white">
        <div className="max-w-7xl mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">

          {/* LEFT CONTENT */}
          <div className="text-center">

            {/* Image */}
            <img
              src="https://confidays.com/wp-content/uploads/2022/05/Marketing-executive-job-vacency-confidays-1024x1024.jpg"
              alt="Marketing executive job vacancy - Confidays"
              className="w-full max-w-md mx-auto rounded-lg shadow-md"
            />

           

            {/* Apply Button */}
            {/* <a
              href="mailto:info@confidays.com"
              className="inline-block  w-full max-w-md py-4 bg-[#151388ff] text-white rounded-md font-medium hover:opacity-90 transition"
            >
              Apply Now
            </a> */}
          </div>

          {/* RIGHT EMPTY COLUMN (matches Elementor layout) */}
          <div />

        </div>
      </section>

    </main>
  );
}
